<!--=================================
=            PROGRESSBAR            =
==================================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Progressbar</div>
      </base-header>
    </v-row>
      <v-row>
        <v-col class="col-12 col-md-4 col-sm-12">
          <base-card>
            <div slot="card-header"> Buffer value</div>


            <div slot="card-subheader">A buffer state represents two values simultaneously. The primary value is
              controlled by v-model, whereas the buffer is controlled by the buffer-value prop.

            </div>
            <div slot="card-body">

              <div>
                <v-progress-linear v-model="value" :buffer-value="bufferValue"></v-progress-linear>
                <br>
                <v-progress-linear v-model="value" :buffer-value="bufferValue" color="purple"></v-progress-linear>
                <br>
                <v-progress-linear v-model="value" :buffer-value="bufferValue" color="red lighten-2">
                </v-progress-linear>
                <br>
                <v-progress-linear v-model="value" :buffer-value="bufferValue" color="black"></v-progress-linear>
              </div>
            </div>
          </base-card>
        </v-col>
        <v-col class="col-12 col-md-4 col-sm-12">

          <base-card>
            <div slot="card-header"> Indeterminate

            </div>
            <div slot="card-subheader">Using the indeterminate prop, v-progress-linear continuously animates.</div>
            <div slot="card-body">

              <div>
                <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
                <br>
                <v-progress-linear indeterminate color="green"></v-progress-linear>
                <br>
                <v-progress-linear indeterminate color="teal"></v-progress-linear>
                <br>
                <v-progress-linear indeterminate color="cyan"></v-progress-linear>
              </div>
            </div>
          </base-card>
        </v-col>
        <v-col class="col-12 col-md-4 col-sm-12">

          <base-card>
            <div slot="card-header"> #Colors

            </div>
            <div slot="card-subheader">You can also set the color using the props color and background-color.</div>
            <div slot="card-body">

              <div class="pa-3">
                <div>
                  <v-progress-linear background-color="pink lighten-3" color="pink lighten-1" value="15">
                  </v-progress-linear>
                  <br>
                  <v-progress-linear background-color="blue-grey" color="lime" value="30"></v-progress-linear>
                  <br>
                  <v-progress-linear background-color="success" color="error" value="45"></v-progress-linear>
                </div>
              </div>
            </div>
          </base-card>
        </v-col>
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header"> Slots


            </div>
            <div slot="card-subheader">The v-progress-linear component will be responsive to user input when using
              v-model. You can use the default slot or bind a local model to display inside of the progress</div>
            <div slot="card-body">

              <div>
                <v-progress-linear v-model="power" color="amber" height="25"></v-progress-linear>

                <br>

                <v-progress-linear v-model="skill" color="blue-grey" height="25">
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>

                <br>

                <v-progress-linear v-model="knowledge" height="25">
                  <strong>{{ Math.ceil(knowledge) }}%</strong>
                </v-progress-linear>
              </div>
            </div>
          </base-card>
        </v-col>
     

        <!-- PROGRESSBAR -->
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header"> Reverse

            </div>
            <div slot="card-subheader">Displays reversed progress (right to left in LTR mode and left to right in RTL).
            </div>
            <div slot="card-body">

              <div>
                <v-progress-linear color="pink" value="15" reverse></v-progress-linear>

                <br>

                <v-progress-linear color="lime" indeterminate reverse></v-progress-linear>

                <br>

                <v-progress-linear buffer-value="55" color="success" reverse stream value="30"></v-progress-linear>

                <br>

                <v-subheader>In specific cases you may want progress to display in left-to-right mode regardless of the
                  application direction (LTR or RTL):</v-subheader>

                <v-progress-linear :reverse="$vuetify.rtl" value="15"></v-progress-linear>
              </div>
            </div>
          </base-card>
        </v-col>
        <v-col class="col-12 col-md-6 col-sm-12">

          <base-card>
            <div slot="card-header"> Rounded

            </div>
            <div slot="card-subheader">The rounded prop is an alternative style that adds a border radius to the
              v-progress-linear component.</div>
            <div slot="card-body">

              <div class="pa-3">
                <div>
                  <v-progress-linear color="red darken-2" rounded value="100"></v-progress-linear>
                  <br>
                  <v-progress-linear color="indigo" rounded value="100"></v-progress-linear>
                  <br>
                  <v-progress-linear color="teal" rounded value="100"></v-progress-linear>
                  <br>
                  <v-progress-linear color="cyan darken-2" rounded value="100"></v-progress-linear>
                </div>
              </div>
            </div>
          </base-card>
        </v-col>
       
        <v-col class="col-12 col-md-6 col-sm-12">

          <base-card>
            <div slot="card-header"> Striped

            </div>
            <div slot="card-subheader">This applies a striped background over the value portion of the
              v-progress-linear.</div>
            <div slot="card-body">

              <div>
                <v-progress-linear color="light-blue" height="10" value="10" striped></v-progress-linear>
                <br>
                <v-progress-linear color="light-green darken-4" height="10" value="20" striped></v-progress-linear>
                <br>
                <v-progress-linear height="10" value="45" striped color="lime"></v-progress-linear>
                <br>
                <v-progress-linear value="60" height="10" striped color="deep-orange"></v-progress-linear>
              </div>
            </div>
          </base-card>
        </v-col>
      <v-col class="col-12 col-md-12 col-sm-12">

          <base-card>
            <div slot="card-header"> Stream

            </div>
            <div slot="card-subheader">The stream property works with buffer-value to convey to the user that there is
              some action taking place. You can use any combination of buffer-value and value to achieve your design.
            </div>
            <div slot="card-body">

              <div>
                <v-progress-linear color="red lighten-2" buffer-value="0" stream></v-progress-linear>
                <br>
                <v-progress-linear color="teal" buffer-value="0" value="20" stream></v-progress-linear>
                <br>
                <v-progress-linear buffer-value="50" stream color="cyan"></v-progress-linear>
                <br>
                <v-progress-linear buffer-value="60" value="40" stream color="orange"></v-progress-linear>
              </div>
            </div>
          </base-card>
        </v-col>

      </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    
  }
</script>

<!--====  End of PROGRESSBAR  ====-->
